// Galerie détaillée par sous-catégories avec descriptions complètes

export const detailedGallery = {
  batiment: {
    title: "Bâtiment",
    description: "Interventions complètes pour l'entretien et la réparation de vos bâtiments",
    fullDescription: `Les travaux sur cordes permettent d'entretenir, de réparer & de pérenniser vos bâtiments sans immobiliser l'espace et sans installation lourde. Nos équipes interviennent directement sur les façades, toiture et structures même en accès complexe.

L'analyse de risque nous permet de vous proposer différentes solutions adaptées sur mesure. En accord avec la règlementation en vigueur sur les travaux sur cordes. Nous travaillons sur tout type de bâtiment, du patrimoine ancien aux constructions récentes, en collaboration avec les syndicats de copropriété, les collectivités locales et les acteurs du BTP.

Nous intervenons sur l'ensemble du secteur Île-de-France.`,
    prestations: [
      'Réparations ponctuelles (Mise hors d\'eau)',
      'Reprise de fissures',
      'Rebouche ou scellement sur façade ou toiture',
      'Restauration complète',
      'Réfection des souches de cheminées',
      'Reprise des couronnements cheminés',
      'Réfection appui de fenêtre, nez de balcon',
      'Ravalement de façades et courette intérieur',
      'Traitement des éléments oxydés',
      'Traitement des pierres de moellons',
      'Intervention d\'urgence',
      'Dépose des éléments instables et dangereux (risque de chute imminente)',
      'Traitement hydrofuge des façades'
    ],
    subcategories: {
      maconnerie: {
        title: "Maçonnerie",
        description: "Réparations ponctuelles, restauration de façades, reprises de fissures",
        images: [
          { 
            id: 'mac1', 
            url: '/images/realisations/real_facade_moellons_avant_apres.jpg', 
            title: 'Traitement des pierres de moellons - Avant/Après', 
            description: 'Restauration façade pierres de moellons. Traitement éléments dégradés, nettoyage complet, façade restaurée et protégée.' 
          },
          { 
            id: 'mac2', 
            url: '/images/realisations/real_appui_fenetre_avant.jpg', 
            title: 'Réfection appui de fenêtre - Avant travaux', 
            description: 'Appui fenêtre dégradé nécessitant intervention. Pierre endommagée, joints défaillants.' 
          },
          { 
            id: 'mac3', 
            url: '/images/realisations/real_appui_fenetre_apres.jpg', 
            title: 'Réfection appui de fenêtre - Après travaux', 
            description: 'Appui fenêtre refait en pierre reconstituée. Finition soignée, étanchéité assurée, protection durable.' 
          },
          { 
            id: 'mac5', 
            url: '/images/realisations/real_cheminee_avant_apres.jpg', 
            title: 'Réfection couronnement cheminée - Avant/Après', 
            description: 'Reprise couronnements cheminée. Avant : souche dégradée. Après : cheminée restaurée, filet anti-volatiles, étanchéité refaite.' 
          },
          { 
            id: 'mac10', 
            url: '/images/realisations/cheminee_avant_apres_grillage.jpg', 
            title: 'Réfection complète souche cheminée avec cage protection - Avant/Après', 
            description: 'Transformation spectaculaire : souche cheminée gravement dégradée entièrement reconstruite. Installation cage protection anti-volatiles en grillage métallique, mise aux normes complète.' 
          },
          { 
            id: 'mac6', 
            url: '/images/realisations/real_facade_avant_apres_multiple.jpg', 
            title: 'Ravalement de façades - Avant/Après', 
            description: 'Ravalement complet façades béton. Traitement zones dégradées, rebouchage, enduit finition, protection longue durée.' 
          },
          { 
            id: 'mac7', 
            url: '/images/realisations/real_acrotere_avant_apres.jpg', 
            title: 'Réfection couronnement cheminée en façade - Avant/Après', 
            description: 'Réfection couronnement en façade très dégradé. Traitement, reconstruction, finition parfaite, protection contre infiltrations.' 
          },
          { 
            id: 'mac8', 
            url: '/images/realisations/real_angle_batiment_avant_apres.jpg', 
            title: 'Réparation angle de bâtiment - Avant/Après', 
            description: 'Intervention angle bâtiment éclat important. Reconstitution pierre, moulures, finition soignée, rendu esthétique parfait.' 
          },
          { 
            id: 'mac9', 
            url: '/images/realisations/real_appui_fenetre_gond_avant_apres.jpg', 
            title: 'Scellement gond de volet sur pierre - Avant/Après', 
            description: 'Scellement gond de volet arraché sur encadrement en pierre. Protection de la zone, traitement et rebouchage soigné, finition discrète et durable.' 
          },
        ]
      }
    }
  },
  
  peinture: {
    title: "Peinture Extérieure",
    description: "Protection et esthétique de vos façades, boiseries et éléments métalliques",
    fullDescription: `La peinture extérieur est un point essentiel de protection à la valeur du bâtiment. Avec le temps, les façades, pignons et éléments métalliques s'altèrent sous l'effet des intempéries : fissures, décoloration, infiltrations.

Une remise en peinture permet de prolonger la durée de vie de l'ouvrage et d'éviter des réparations souvent plus coûteuses et plus lourdes. Nos interventions sur cordes offrent une alternative aux échafaudages.`,
    prestations: [
      'Préparation des supports (Nettoyage, ponçage)',
      'Application de différentes peintures adaptées aux supports & matériaux',
      'Bois : Chien assis & garde-corps, fenêtres (Peinture acrylique)',
      'Fer : Garde-corps métalliques (Protection anti-corrosion)',
      'Balcon, Façade & couronnement (Latex et siloxane)',
      'Traitement des fissures',
      'Protection contre la décoloration',
      'Prévention des infiltrations'
    ],
    subcategories: {
      peinture: {
        title: "Peinture",
        description: "Peinture de façades, boiseries et éléments métalliques - Protection et esthétique",
        images: [
          { 
            id: 'pei1', 
            url: '/images/realisations/real_peinture_couronnement_progression.jpg', 
            title: 'Traitement bois & mise en peinture', 
            description: 'Remise en peinture couronnement. État initial gris, préparation, finition blanche. Peinture latex et siloxane.',
            fit: 'contain'
          },
          { 
            id: 'pei2', 
            url: '/images/realisations/real_peinture_volets_avant_apres.jpg', 
            title: 'Peinture volets bois - Avant/Après', 
            description: 'Rénovation volets bois. Avant : décolorés écaillés. Après : gris anthracite, finition acrylique haute résistance.' 
          },
          { 
            id: 'pei3', 
            url: '/images/realisations/real_peinture_descentes_progression.jpg', 
            title: 'Mise en peinture tête de mur', 
            description: 'Peinture descentes métalliques. Ponçage, sous-couche, finition. Protection anti-corrosion longue durée.',
            fit: 'contain'
          },
        ]
      }
    }
  },
  
  ouvragesTechniques: {
    title: "Ouvrages Techniques",
    description: "Installations et réparations techniques en accès difficile",
    fullDescription: `Nos équipes interviennent pour des installations techniques complexes en hauteur : création de verrières sur mesure, remplacement de carreaux et vitrages, installation de garde-corps et points d'ancrage certifiés, pose d'échelles crinoline, bardage et habillage de façades.

Tous nos ouvrages respectent les normes de sécurité en vigueur et sont réalisés par des cordistes qualifiés.`,
    prestations: [
      'Création de verrière sur mesure en structures métalliques',
      'Remplacement de carreau fenêtre ou verrière',
      'Remplacement moteurs stores défectueux',
      'Bardage bois ou aluminium sur corde',
      'Mise en place garde-corps définitif ou temporaire',
      'Pose point ancrages certifié CE',
      'Pose échelle crinoline'
    ],
    subcategories: {
      ouvragesTechniques: {
        title: "Ouvrages Techniques",
        description: "Installations techniques et équipements de sécurité en hauteur",
        images: [
          { 
            id: 'ot1', 
            url: '/images/realisations/ouvrages_tech_1.jpg', 
            title: 'Accès toitures parisiennes', 
            description: 'Installation échelles et dispositifs accès sécurisés toitures zinc. Bâtiments patrimoniaux, respect architecture.' 
          },
          { 
            id: 'ot2', 
            url: '/images/realisations/ouvrages_tech_2.jpg', 
            title: 'Verrières et structures métalliques', 
            description: 'Toitures parisiennes. Création réparation verrières sur mesure, remplacement carreaux, entretien structures métalliques.' 
          },
          { 
            id: 'ot3', 
            url: '/images/realisations/ouvrages_tech_3.jpg', 
            title: 'Installation échelle crinoline', 
            description: 'Pose échelle crinoline sécurité façade industrielle. Cordistes qualifiés, installation conforme normes CE.' 
          },
          { 
            id: 'ot4', 
            url: '/images/realisations/ouvrages_tech_4.jpg', 
            title: 'Point d\'ancrage certifié CE', 
            description: 'Installation point ancrage permanent certifié CE toiture. Dispositif essentiel travaux hauteur, maintenance bâtiments.' 
          },
          { 
            id: 'ot5', 
            url: '/images/realisations/ouvrages_tech_5.jpg', 
            title: 'Remplacement moteur store', 
            description: 'Intervention store-banne défectueux. Remplacement moteur, vérification système. Accès cordes sans échafaudage.' 
          },
        ]
      }
    }
  },
  
  evenementiel: {
    title: "Événementiel",
    description: "Publicité et signalétique en hauteur pour renforcer votre visibilité",
    fullDescription: `Nos équipes interviennent aussi dans le secteur de l'événementiel pour renforcer votre visibilité au maximum. Nous proposons des solutions techniques adaptées, durables et à coûts maîtrisés.

L'accès par cordes permet une pose rapide sans échafaudage ni nacelle, minimisant l'impact sur votre activité.`,
    prestations: [
      'Pose d\'adhésif vinyle micro-perforé',
      'Pose de film solaire anti-UV',
      'Support publicitaire grand format',
      'Pose enseigne lumineuse LED',
      'Bâches publicitaires et habillage de chantier',
      'Visibilité extérieure / Transparence intérieure',
      'Protection complémentaire',
      'Adapté aux accès difficiles',
      'Coût maîtrisé et renouvelable',
      'Visibilité maximale jour & nuit',
      'Personnalisation complète',
      'Résistance extérieur',
      'Monétisation du chantier'
    ],
    subcategories: {
      evenementiel: {
        title: "Événementiel",
        description: "Solutions publicitaires et signalétiques en hauteur",
        images: [
          { 
            id: 'eve1', 
            url: '/images/realisations/evenementiel_1.jpg', 
            title: 'Adhésifs vinyle et film solaire', 
            description: 'Adhésif vinyle micro-perforé, film solaire anti-UV vitrage immeuble. Visibilité extérieure, transparence intérieure, accès difficiles, coût maîtrisé.',
            fit: 'contain'
          },
          { 
            id: 'eve2', 
            url: '/images/realisations/evenementiel_2.jpg', 
            title: 'Enseigne lumineuse LED', 
            description: 'Enseigne LED lettres capitales façade. Visibilité jour nuit, LED faible consommation, personnalisation complète, résistance extérieure.',
            fit: 'contain'
          },
          { 
            id: 'eve3', 
            url: '/images/realisations/evenementiel_3.jpg', 
            title: 'Bâche publicitaire grand format', 
            description: 'Bâche publicitaire façade hauteur. Visibilité maximale, monétisation chantier, habillage esthétique, pose rapide sans échafaudage.',
            fit: 'contain'
          },
        ]
      }
    }
  },
  
  securite: {
    title: "Mise en Sécurité",
    description: "Protection des personnes et des biens, conformité chantier",
    fullDescription: `Ces interventions permettent de limiter les risques d'infiltration, les chutes de matériaux, les accidents et les dégradations, tout en assurant la conformité des ouvrages et la sécurité des personnes.`,
    prestations: [
      'Pose de filet anti-chute d\'homme et de pierre',
      'Sécurité des personnes',
      'Protection des tiers et des biens',
      'Conformité chantier',
      'Souplesse de mise en œuvre',
      'Réduction des coûts indirects',
      'Image professionnelle & rassurante',
      'Pose de pics anti-volatiles',
      'Empêche le perchage et nidification',
      'Protège le bâti',
      'Hygiène & Salubrité',
      'Solution discrète et durable',
      'Pose ciblée & adaptable',
      'Coût maîtrisé & entretien réduit'
    ],
    subcategories: {
      securite: {
        title: "Mise en Sécurité",
        description: "Solutions de protection et sécurisation en hauteur",
        images: [
          { 
            id: 'sec1', 
            url: '/images/realisations/securite_1.jpg', 
            title: 'Pose de filet anti-chute d\'homme et de pierre', 
            description: 'Cordistes professionnels installant un filet de protection sur toiture parisienne. Sécurité des personnes, protection des tiers et des biens, conformité chantier, souplesse de mise en œuvre, réduction des coûts indirects, image professionnelle et rassurante.' 
          },
          { 
            id: 'sec2', 
            url: '/images/realisations/securite_2.jpg', 
            title: 'Pose de pics anti-volatiles', 
            description: 'Installation de pics anti-volatiles par cordiste équipé. Empêche le perchage et nidification, protège le bâti, hygiène & salubrité, solution discrète et durable, pose ciblée & adaptable, coût maîtrisé & entretien réduit.' 
          },
        ]
      }
    }
  },
  
  nettoyage: {
    title: "Nettoyage",
    description: "Entretien régulier pour préserver l'apparence et protéger les matériaux",
    fullDescription: `L'entretien régulier d'un bâtiment permet de préserver l'apparence et de protéger les matériaux et d'éviter la dégradation des surfaces exposées. Nos équipes réalisent différents nettoyages en hauteur avec des méthodes modernes et utilisent des équipements adaptés afin de garantir un résultat propre, uniforme et durable. Nous intervenons sur tous type de bâtiments : résidentiel, industriel, ou public, en proposant un service complet et adapté.`,
    prestations: [
      'Contrat d\'entretien nettoyage chéneaux et inspection toiture',
      'Nettoyage de vitre',
      'Nettoyage de Façades (Haute pression)',
      'Nettoyage toiture (démoussage)',
      'Application d\'un traitement hydrofuge protecteur',
      'Dépoussiérage structure métallique',
      'Vérification des joints et de l\'étanchéité'
    ],
    subcategories: {
      nettoyage: {
        title: "Nettoyage",
        description: "Services de nettoyage professionnel en hauteur",
        images: [
          { 
            id: 'net1', 
            url: '/images/realisations/nettoyage_1.jpg', 
            title: 'Nettoyage de vitre', 
            description: 'Nettoyage vitres immeuble hauteur. Préserve esthétique, propreté bâtiment, service régulier ou ponctuel.' 
          },
          { 
            id: 'net2', 
            url: '/images/realisations/nettoyage_2.jpg', 
            title: 'Nettoyage toiture (démoussage)', 
            description: 'Démoussage toiture haute pression. Augmente longévité couverture, évite réparations coûteuses, traitement préventif.' 
          },
          { 
            id: 'net3', 
            url: '/images/realisations/nettoyage_3.jpg', 
            title: 'Nettoyage de Façades (Haute pression)', 
            description: 'Nettoyage façade haute pression. Longévité logement, prévient dommages humidité, rehausse valeur, prévient mousses champignons.' 
          },
        ]
      }
    }
  },
  
  maintenance: {
    title: "Entretien & Maintenance",
    description: "Contrats d'entretien avec suivi précis et rapports réguliers",
    fullDescription: `Les syndicats et gestionnaire ont besoin de visibilité sur l'état du patrimoine et sur les dépenses à venir. Le contrat d'entretien offre un suivi précis annuel, un planning d'interventions et des rapports réguliers avec préconisations si nécessaire, permettant de faciliter la prise de décisions afin de hiérarchiser par priorité les interventions.

Cette action permet aux syndicats, architectes ou maîtres d'ouvrage de pouvoir mettre en place des actions préventives et correctives afin de préserver le plus longtemps possible la viabilité du bien.`,
    prestations: [
      'Suivi précis annuel',
      'Planning d\'interventions',
      'Rapports réguliers avec préconisations',
      'Bâtiment propre toute l\'année',
      'Risques réduits',
      'Diagnostics réguliers',
      'Budget maîtrisé'
    ],
    subcategories: {
      maintenance: {
        title: "Entretien & Maintenance",
        description: "Audit structurel et inspections techniques",
        images: [
          { 
            id: 'mai1', 
            url: '/images/realisations/maintenance_1.jpg', 
            title: 'Audit bâtiment sur corde', 
            description: 'Audit technique accès difficile. Inspection ciblée, diagnostic sans échafaudage, rapport détaillé, intervention rapide.' 
          },
          { 
            id: 'mai2', 
            url: '/images/realisations/maintenance_2.jpg', 
            title: 'Inspection structure en fer', 
            description: 'Inspection structure fer IPN linteaux. Constat avancement rouille, traitement ou remplacement pièce.' 
          },
          { 
            id: 'mai4', 
            url: '/images/realisations/maintenance_4.jpg', 
            title: 'Diagnostic bois dégradé', 
            description: 'Bois dégradé nécessitant intervention. Détection précoce, évaluation dommages, recommandations actions correctives.' 
          },
        ]
      }
    }
  },

  toiture: {
    title: "Toiture & Couverture",
    description: "Réfection, réparation et étanchéité de toitures",
    fullDescription: `Une intervention en toiture demande souvent une connaissance du terrain et une bonne réactivité. Une bonne organisation sur zones complexes peut permettre d'agir rapidement, notamment en cas d'infiltrations ou de tuiles à remplacer. Solution adaptée en sécurisation ou de remise en état que ce soit en urgence ou en préventif.`,
    prestations: [
      'Réfection de solin d\'étanchéité zinc',
      'Réfection appui fenêtre zinc / couvertines',
      'Bande de noue / Bande de rives / Bande solin',
      'Traitement hydrofuge toiture & démoussage',
      'Remplacement de tuile, ardoise cassées ou déplacées',
      'Petits travaux d\'étanchéité type Viral et bande à froid',
      'Détection & Recherche de fuite sous 24 à 48 Heures'
    ],
    subcategories: {
      toiture: {
        title: "Toiture & Couverture",
        description: "Travaux de toiture et d'étanchéité",
        images: [
          { 
            id: 'toi1', 
            url: '/images/realisations/toiture_couvertine_avant_apres.jpg', 
            title: 'Réfection couvertine - Avant/Après', 
            description: 'Réfection complète couvertine et coffre cheminée zinc. État initial dégradé restauré, étanchéité rétablie, finition professionnelle.' 
          },
          { 
            id: 'toi2', 
            url: '/images/realisations/toiture_2.jpg', 
            title: 'Remplacement ardoises', 
            description: 'Remplacement ardoises cassées déplacées. Toiture réparée, étanchéité rétablie, durabilité assurée.' 
          },
          { 
            id: 'toi4', 
            url: '/images/realisations/toiture_4.jpg', 
            title: 'Bande de rives', 
            description: 'Pose bande rives zinc. Protection rives toiture, finition soignée, durabilité assurée.' 
          },
          { 
            id: 'toi5', 
            url: '/images/realisations/toiture_5.jpg', 
            title: 'Réfection solin zinc', 
            description: 'Travaux solin étanchéité zinc. Protection cheminée, étanchéité parfaite, intervention urgence ou préventif.' 
          },
          { 
            id: 'toi8', 
            url: '/images/realisations/toiture_terrasse_zinc.jpg', 
            title: 'Façonnage pièce zinc en tête de mur', 
            description: 'Toiture-terrasse professionnelle avec bandes zinc et relevés. Étanchéité complète, évacuations intégrées, finition soignée.' 
          },
          { 
            id: 'toi9', 
            url: '/images/realisations/toiture_terrasse_panorama_paris.jpg', 
            title: 'Façonnage pièce zinc en tête de mur', 
            description: 'Intervention toiture-terrasse en hauteur Paris. Vue panoramique depuis zone de travail, garde-corps sécurisés, étanchéité terrasse, accès difficile.' 
          },
        ]
      }
    }
  },

  descentes: {
    title: "Descente Pluviale & Fumisterie",
    description: "Réparation et remplacement des systèmes d'évacuation",
    fullDescription: `Des gouttières ou chéneaux bouchés peuvent provoquer des infiltrations importantes et traces d'humidité. Cela peut potentiellement entraînant des dégradations importantes et réparations coûteuses. Nos équipes interviennent en accès difficile pour réparer ou remplacer les systèmes d'évacuation des eaux dites fuyards.`,
    prestations: [
      'Remplacement descentes eaux pluviales et usées Zinc/ PVC/ Fonte/ Aluminium',
      'Création & connexion de nouveaux raccordement sur colonne',
      'Débouchage haute pression ou furet',
      'Traitement des descentes fuyards',
      'Création colonne montante EF Général'
    ],
    subcategories: {
      descentes: {
        title: "Descente Pluviale & Fumisterie",
        description: "Réparation et remplacement descentes pluviales",
        images: [
          { 
            id: 'des1', 
            url: '/images/realisations/descente_1.jpg', 
            title: 'Descente dégradée', 
            description: 'Tuyau descente rouillé nécessitant remplacement. Infiltrations, traces humidité, intervention urgente.' 
          },
          { 
            id: 'des2', 
            url: '/images/realisations/descente_2.jpg', 
            title: 'Descente eaux pluviales fonte', 
            description: 'Installation descente zinc immeuble. Accès difficile, pose professionnelle, évacuation eaux assurée.' 
          },
          { 
            id: 'des3', 
            url: '/images/realisations/descente_3.jpg', 
            title: '', 
            description: 'Système évacuation chéneaux toiture. Nettoyage, débouchage, raccordement descentes.' 
          },
          { 
            id: 'des4', 
            url: '/images/realisations/descente_4.jpg', 
            title: 'Installation descente complète fonte', 
            description: 'Descente complète façade immeuble parisien. Installation zinc, raccordements, évacuation eaux pluviales usées.' 
          },
          { 
            id: 'fum1', 
            url: '/images/realisations/fumisterie_1.jpg', 
            title: 'Installation conduit ventouse', 
            description: 'Cordiste installant conduit ventouse chaudière par carottage. Intervention façade, installation sécurisée, évacuation fumées.' 
          },
          { 
            id: 'fum2', 
            url: '/images/realisations/fumisterie_2.jpg', 
            title: 'Sortie ventouse chaudière', 
            description: 'Installation conduit ventouse chaudière par carottage. Sortie façade, finition soignée, évacuation conforme.' 
          },
          { 
            id: 'fum3', 
            url: '/images/realisations/fumisterie_3.jpg', 
            title: 'Conduits inox hottes restaurants', 
            description: 'Installation conduits inox et moteur hottes restaurants. Évacuation fumées, conformité normes, intervention accès difficile.' 
          },
          { 
            id: 'des5', 
            url: '/images/realisations/descente_remplacement_1.jpg', 
            title: 'Remplacement raccord défectueux', 
            description: 'Comparaison avant/après remplacement descente. Ancienne descente rouillée remplacée par PVC neuf, évacuation optimale.' 
          },
          { 
            id: 'des6', 
            url: '/images/realisations/descente_remplacement_2.jpg', 
            title: 'Rénovation système évacuation - Multiples interventions', 
            description: 'Remplacement complet descentes dégradées. Avant : tuyaux rouillés et fuyards. Après : système PVC neuf étanche et durable.' 
          },
        ]
      }
    }
  }
};

export const backgroundImages = {
  hero: '/images/realisations/real_cheminee_avant_apres.jpg',
  about: '/images/realisations/real_facade_moellons_avant_apres.jpg',
  services: '/images/realisations/image22.jpeg',
  gallery: '/images/realisations/image24.jpeg',
  contact: '/images/realisations/image40.jpeg'
};
